'use strict';

const passRules = {
  settings: {
    $pass: document.getElementById('password_user'),
    $confirmPass: document.getElementById('password_confirmation'),
    $danger: document.querySelector('[data-error]'),
    submit: false,
    regex: /^(?=.*[A-Z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.*[0-9])(?=.*[a-z]).{8,}$/,
    $passInputs: document.querySelectorAll('#password_confirmation, #password_user'),
  },

  rules: {
    complexPassword() {
      if (!s.regex.exec(s.$pass.value)) {
        s.submit = false;
        return false;
      }
      return true;
    },

    confirmation() {
      if (s.$pass.value != s.$confirmPass.value) {
        s.submit = false;
        return false;
      }

      return true;
    },

    minLength() {
      if (s.$pass.value.length < 8) {
        s.submit = false;
        return false;
      } else {
        return true;
      }
    },
  },

  message(msg) {
    if (s.$danger) {
      if (msg) {
        s.$danger.innerHTML = msg;
        s.$danger.style.display = 'block';
      } else {
        s.$danger.innerHTML = '';
        s.$danger.style.display = 'none';
      }
    }
  },

  init() {
    s.$passInputs.length &&
      s.$passInputs.forEach(item => {
        item.addEventListener('input', function () {
          _this.message(false);

          if (!_this.rules.confirmation()) {
            _this.message('Senhas diferentes.');
          } else if (!_this.rules.minLength()) {
            _this.message('A senha precisa ter o mínimo de 8 caracteres.');
          } else if (!_this.rules.complexPassword()) {
            _this.message('A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais.');
          } else {
            s.submit = true;
          }
        });
      });
  },
};

const s = passRules.settings,
  _this = passRules;

export default passRules;
